type TSnackbarDictionaryItem = {
  id: string;
  title: string;
  content: string;
  type: string;
  time: boolean;
};

type TSnackbarDictionary = {
  [key: string]: TSnackbarDictionaryItem;
};

export enum TSnackbarDictionaryKeys {
  CALCULATION_ERROR = 'calculationError',
  SUCCESSFULY_ADD_TO_CART = 'successfulyAddedToCart',
  ERROR_ADD_TO_CART = 'errorAddToCart',
}

export const SNACKBARS_DICTIONARY: TSnackbarDictionary = {
  calculationError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось расчитать товары',
    type: 'alert',
    time: true,
  },
  serviceError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось перейти к оформлению замера',
    type: 'alert',
    time: true,
  },
  successfulyAddedToCart: {
    id: `${TSnackbarDictionaryKeys.SUCCESSFULY_ADD_TO_CART}`,
    title: 'Товары добавлены в корзину',
    content: 'Перейдите в корзину для оформления или продолжите покупки',
    type: 'success',
    time: true,
  },
  errorAddToCart: {
    id: `${TSnackbarDictionaryKeys.ERROR_ADD_TO_CART}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось добавить товары в корзину',
    type: 'alert',
    time: true,
  },
};
